import { SocialSharing } from '@ionic-native/social-sharing';
import { Platform } from 'ionic-angular';
import { MaskType } from '../directives/mask-directive';
import { NotificationType } from '../enums/notification-type.enum';
import { VersionCompare } from '../enums/version-compare.enum';
import {
  CommunicationError,
  CommunicationResponse,
  ConfirmationResponse,
} from '../models/communication-response.model';
import { Country } from '../models/country.model';
import { Translation, TranslationField } from '../models/translation.model';

export class UtilHelper {
  public static getEnumByCod(code: any, obj: any): any {
    const key: string = Object.keys(obj).find((k: string) => {
      return obj[k].code === code;
    });
    return obj[key];
  }

  public static getIdFromLocationPath(location: string): string {
    let id: string = null;
    if (location && location.length > 0) {
      const respSplited: Array<string> = location.split('/');
      if (respSplited.length > 0) {
        id = respSplited[respSplited.length - 1];
      }
    }
    return id;
  }

  public static getNumericValueIfPossible(value: any): number | string {
    let newValue: any = value;
    try {
      if (!isNaN(value)) {
        newValue = Number(value);
      }
    } catch {
      newValue = value;
    }
    return newValue;
  }

  public static unmask(value: string): string {
    if (!value) return '';
    return value.replace(/[^a-z0-9]/gi, '');
  }

  public static removeLinksAndInvalidKeywords(value: string): string {
    if (!value) return '';
    return value.replace(/(?:https?:\/\/|www\.)?\S+\.\S+|\b(sedex|correios)\b/gi, '').trim();
  }

  public static formatAmountAndRemoveNegativeSymbol(amount: number): string {
    if (amount == null) return '';
    let amountFormated: string = String(amount.toFixed(2));
    amountFormated = amountFormated.replace('-', '').replace('.', ',');
    return amountFormated;
  }

  public static getTranslationByField(
    translations: Translation[],
    field: TranslationField
  ): Translation {
    if (translations && translations.length > 0) {
      return translations.find((t) => t.field == field);
    }
    return null;
  }

  public static checkCommunicationStatus(
    response: ConfirmationResponse,
    storeNotificationTypes: NotificationType[]
  ): CommunicationResponse {
    if (response && response.comunicationResponse && !response.comunicationResponse.success) {
      let hasSMSorWhatsApp = (storeNotificationTypes || []).find(
        (type) => type == NotificationType.SMS || type == NotificationType.WHATSAPP_AUTO
      );
      if (
        hasSMSorWhatsApp &&
        response.comunicationResponse.code == CommunicationError.WALLET_INSUFFICIENT_BALANCE
      ) {
        return response.comunicationResponse;
      }
    } else {
      return null;
    }
  }

  public static getBoolPrefs(key: string, id?: string, defaultValue?: boolean): boolean {
    if (!id) id = '';
    let prefs = localStorage.getItem(key + id || 'all');
    console.log(prefs);
    if (prefs == null) {
      return defaultValue || false;
    }
    return prefs == 'true';
  }

  public static getCustomPrefs(key: string, id?: string): any {
    if (!id) id = '';
    let prefs = localStorage.getItem(key + id || 'all');
    console.log(prefs);
    return prefs;
  }

  public static setPrefs(key: string, value: string, id?: string): void {
    if (!id) id = '';
    localStorage.setItem(key + id || 'all', value);
  }

  public static capitalizeFirst(value: string) {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1);
  }

  public static orderListByStatusAndOrder(list: any[]): any[] {
    if (list && list.length > 0) {
      list.sort((a, b) => {
        // Se os dois produtos são ativos, ordena pela ordem
        if (a.status['code'] === 'ACTIVE' && b.status['code'] === 'ACTIVE') {
          return a.order - b.order;
        }
        // Se apenas um dos produtos é ativo, coloca o ativo primeiro
        else if (a.status['code'] === 'ACTIVE') {
          return -1;
        } else if (b.status['code'] === 'ACTIVE') {
          return 1;
        }
        // Se os dois produtos são inativos ou outro status, não altera a ordem
        else {
          return 0;
        }
      });
    }
    return list;
  }

  public static getDayOfWeekById(id: number): string {
    const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    return days[id - 1];
  }

  public static getIdDayOfWeekByDay(day: string): number {
    const days = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
    const index = days.findIndex((d) => d == day);
    return index + 1;
  }

  public static mask(v: string, mask: string): string {
    if (!v) return v;
    let s: string = '';

    const matches: RegExpMatchArray = String(v).match(/[a-zA-Z0-9]+/g);
    if (matches !== null) {
      if (mask == null) return;

      let value: Array<string> = matches.join('').split('');
      const chars: Array<string> = mask.split('');
      for (const c of chars) {
        if (value.length === 0) {
          break;
        }
        switch (c) {
          case '#': //qualquer
            s += value[0];
            value = value.slice(1);
            break;

          case '9':
            if (value[0].match(/\d/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;

          case 'A':
            if (value[0].match(/[a-zA-Z]/) !== null) {
              s += value[0];
              value = value.slice(1);
            }
            break;

          default:
            s += c;
        }
      }
      return s;
    }
  }

  public static getCountryPhoneCode(countries: Country[], code: string): Country {
    const country: Country = countries.find((c: Country) => {
      return UtilHelper.unmask(c.dial_code) == code;
    });
    return country || new Country({ name: 'Brazil', flag: '🇧🇷', code: 'BR', dial_code: '+55' });
  }

  public static getCountryCodeMask(countryPhoneCode: string): any {
    const code: string = UtilHelper.unmask(countryPhoneCode);
    if (code == '55') {
      return { type: MaskType.CELLPHONE };
    } else {
      return { mask: '99999999999999999' };
    }
  }

  public static async copyToClipboard(text: string): Promise<void> {
    try {
      await window.navigator['clipboard'].writeText(text);
    } catch (error) {
      console.log(error);
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  }

  public static shareLink(
    link: string,
    message: string,
    platform: Platform,
    socialSharing: SocialSharing
  ): void {
    if (platform.is('core')) {
      UtilHelper.copyToClipboard(link);
      throw new Error(
        'O link foi <b>copiado</b>, basta colar nas suas redes sociais ou WhatsApp.<br><br>Para uma melhor experiência, baixe o aplicativo <b>Fastget Parceiros</b>, e compartilhe direto pelo WhatsApp ou Redes Sociais.'
      );
    } else {
      const errorCallback: any = (error) => {
        console.error(error);
        UtilHelper.copyToClipboard(link);
        throw new Error('Ocorreu um erro ao tentar compartilhar, mas o link foi copiado.');
      };
      if (platform.is('cordova')) {
        const options: any = {
          message: message,
          url: link,
          chooserTitle: 'Compartilhar via:',
        };
        socialSharing.shareWithOptions(options).catch((error) => {
          errorCallback(error);
        });
      } else {
        try {
          (navigator as any)
            .share({
              title: message,
              url: link,
            })
            .catch((error) => {
              errorCallback(error);
            });
        } catch (error) {
          errorCallback(error);
        }
      }
    }
  }

  /**
   * Compara versões
   * @param localVersion
   * @param remoteVersion
   */
  public static compareVersions(localVersion: string, remoteVersion: string): VersionCompare {
    if (localVersion === remoteVersion) {
      return VersionCompare.IDENTICAL_VERSIONS;
    }

    const local_components: Array<string> = localVersion.split('.');
    const remote_components: Array<string> = remoteVersion.split('.');

    const len: number = Math.min(local_components.length, remote_components.length);

    // loop while the components are equal
    for (let i: number = 0; i < len; i++) {
      // Local maior que remoto
      if (parseInt(local_components[i]) > parseInt(remote_components[i])) {
        return VersionCompare.LOCAL_VERSION_HIGHER;
      }

      // Remoto maior que local
      if (parseInt(local_components[i]) < parseInt(remote_components[i])) {
        return VersionCompare.REMOTE_VERSION_HIGHER;
      }
    }

    // If one's a prefix of the other, the longer one is greater.
    if (local_components.length > remote_components.length) {
      return VersionCompare.LOCAL_VERSION_HIGHER;
    }

    if (local_components.length < remote_components.length) {
      return VersionCompare.REMOTE_VERSION_HIGHER;
    }

    // Otherwise they are the same.
    return VersionCompare.IDENTICAL_VERSIONS;
  }

  /**
   * Scroll horizontal.
   * Adaptação do código https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5
   * @param to
   * @param element
   * @param duration
   */
  public static scrollHorizontalTo(
    to: number,
    element: HTMLElement,
    duration: number = 500
  ): Promise<void> {
    //t = current time
    //b = start value
    //c = change in value
    //d = duration
    const easeInOutQuad: any = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    };

    return new Promise((resolve) => {
      const start: number = element.scrollLeft,
        change: number = to - start,
        increment: number = 20;

      let currentTime: number = 0;

      const animateScroll: VoidFunction = () => {
        currentTime += increment;
        const val: any = easeInOutQuad(currentTime, start, change, duration);
        element.scrollLeft = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        } else {
          resolve();
        }
      };
      animateScroll();
    });
  }

  public static getStates(): Array<any> {
    return [
      { key: 'AC', value: 'Acre' },
      { key: 'AL', value: 'Alagoas' },
      { key: 'AP', value: 'Amapá' },
      { key: 'AM', value: 'Amazonas' },
      { key: 'BA', value: 'Bahia' },
      { key: 'CE', value: 'Ceará' },
      { key: 'DF', value: 'Distrito Federal' },
      { key: 'ES', value: 'Espírito Santo' },
      { key: 'GO', value: 'Goiás' },
      { key: 'MA', value: 'Maranhão' },
      { key: 'MT', value: 'Mato Grosso' },
      { key: 'MS', value: 'Mato Grosso do Sul' },
      { key: 'MG', value: 'Minas Gerais' },
      { key: 'PA', value: 'Pará' },
      { key: 'PB', value: 'Paraíba' },
      { key: 'PR', value: 'Paraná' },
      { key: 'PE', value: 'Pernambuco' },
      { key: 'PI', value: 'Piauí' },
      { key: 'RJ', value: 'Rio de Janeiro' },
      { key: 'RN', value: 'Rio Grande do Norte' },
      { key: 'RS', value: 'Rio Grande do Sul' },
      { key: 'RO', value: 'Rondônia' },
      { key: 'RR', value: 'Roraima' },
      { key: 'SC', value: 'Santa Catarina' },
      { key: 'SP', value: 'São Paulo' },
      { key: 'SE', value: 'Sergipe' },
      { key: 'TO', value: 'Tocantins' },
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/utils.helper.ts